import type { RefObject } from 'react';

type Props = {
    ref?: RefObject<HTMLElement | null>,
};

export default function WhatWeDoSection({ ref }: Props) {
    return <section
        ref={ref}
        className="relative flex min-h-[480px] md:min-h-[800px] justify-between border-brand border-y-2"
    >
        <div className="absolute top-0 w-1/2 w-full h-full z-5 bg-linear-to-r from-black to-transparent opacity-50"></div>
        <div className="absolute top-0 w-full h-full z-4 bg-fixed bg-cover bg-no-repeat bg-[url(https://oursharestudios.imgix.net/stock/studio-space-warm-man.png?q=80&fit=crop&crop=focalpoint&fp-x=0.6&fp-y=0.5&fp-z=0.5&ar=16:9)]"></div>
        <div className="relative flex flex-col justify-between z-10">
            <div className="relative p-4 md:p-8 min-h-[560px] text-font z-10">
                <div className="relative grid grid-cols-1 md:grid-cols-2 grid-rows-1 py-16 w-full h-full z-10">
                    <div className="flex flex-col justify-between items-start px-4 md:px-8 gap-16 border-font">
                        <h1 className="text-3xl md:text-6xl tracking-wide font-bold uppercase">
                            And We Do Mean{" "}
                            <span className="border-b-4 italic">
                                Fair
                            </span>
                        </h1>

                        <div className="text-lg md:text-xl font-medium uppercase max-w-[560px]">
                            <p>
                                We reward the people doing the actual work
                                by giving them a cut of the earnings.
                            </p>

                            <br />

                            <h2>The Result?</h2>

                            <br />

                            <p>
                                A deeper collaboration, and a
                                shared ownership means you get a team of
                                creatives who are fairly rewarded for their
                                exceptional work.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
}
